import { QueryColumn } from "@barthauer/abc/core/data";
import { ObjectKeys } from "../constants";


export class ReadObjectsInputMain {
  objectKey: ObjectKeys;
  opath?: string;
  columns?: Array<string>;
  specialColumns?: Array<QueryColumn>;
  objectQueries?: ReadObjectsInputQueries[];
  limitCount?: number;
  limitOffset?: number;

  constructor(data: ReadObjectsInputMain) {
    Object.assign(this, data);
  }
}

export class ReadObjectsInputQueries {
  columns?: Array<string>;
  opath: string;
  name: string;
  specialColumns?: Array<QueryColumn>;
  objectQueries?: ReadObjectsInputQueries[];
  limitCount?: number;
  limitOffset?: number;

  constructor(data: ReadObjectsInputQueries) {
    Object.assign(this, data);
  }
}